import React from "react"
import styled from "@emotion/styled"
import { StaticQuery, graphql } from "gatsby"

import PairSection from "components/shared/PairSection"
import Button from "components/shared/Button"
import TextMeSection from './TextMeSection'

const Container = styled.div`
  margin-top: 150px;
`

const FooterCTA = styled.div`
  margin: 100px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h1`
  margin-bottom: 20px;
  font-weight: 650;
   /*font-family: "Avenir Next";*/
`

const SubTitle = styled.h3`
      /*font-family: "Avenir Next";*/
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 20px;
    color: #222;
`

export default () => (
  <Container>
    <Title>How does it work?</Title>
    <SubTitle>Get started in minutes</SubTitle>
    <StaticQuery
      query={graphql`
        query {
          tweet: file(relativePath: { eq: "home/tweet2.png" }) {
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
          phone: file(relativePath: { eq: "home/messages.png" }) {
            childImageSharp {
              fluid(maxWidth: 700) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
          chart: file(relativePath: { eq: "home/bubble.png" }) {
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      `}
      render={data => (
        <>
          <PairSection
            subTitle="Step 1"
            title="Tell your fans"
            subSection={
              <>
                <p>
                  Reach out to your fans to let them know they'll have a new way
                  to keep up and a direct way to connect.
                </p>
              </>
            }
            image={data.tweet.childImageSharp.fluid}
            imageWidth={80}
            phoneWidth={100}
          />
          <PairSection
            reverse
            subTitle="Step 2"
            title="Text your followers"
            subSection={
              <>
                <p>
                  Use our inbox to text your followers individually or all at once with your new number. Create meaningful conversations at scale.
                </p>
              </>
            }
            image={data.phone.childImageSharp.fluid}
            center
            imageWidth={40}
            phoneWidth={100}
          />
          <PairSection
            subTitle="Step 3"
            title="Build relationships and grow a community"
            subSection={
              <>
                <p>
                  Share product launches, exclusive announcements, life updates,
                  and instantly connect with your most interested followers.
                </p>
              </>
            }
            image={data.chart.childImageSharp.fluid}
            imageWidth={34}
            phoneWidth={60}
          />
        </>
      )}
    />
    <TextMeSection/>
    <FooterCTA>
      <h1>Join a community of creatives.</h1>
      <div>
        <Button to="/sign-up">
          Get your number<span>→</span>
        </Button>
      </div>
    </FooterCTA>
  </Container>
)
